import { IIceMode } from "../models/IIceMode";
import { IRtcConnectionStatsInfo } from "../models/IRtcConnectionStatsInfo";

export function iceModeFromRtcConnectionStatsInfo(
    info: IRtcConnectionStatsInfo,
): IIceMode {
    const localType = info.localCandidate.candidateType;
    const remoteType = info.remoteCandidate.candidateType;

    if (localType === "host" && remoteType === "host") {
        return "local";
    } else if (localType === "relay" || remoteType === "relay") {
        return "TURN";
    } else {
        return "STUN";
    }
}
